import Search from 'antd/es/input/Search'
import React, { useCallback, useRef, useState } from 'react'

interface FAQFilterProps {
  onSearch: (text: string) => void;
}

const FAQFilter: React.FC<FAQFilterProps> = ({ onSearch }) => {

  const [searchText, setSearchText] = useState("");

  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleInputChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const text = e.target.value;
      setSearchText(text);

      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }

      debounceRef.current = setTimeout(() => {
        onSearch(text);
      }, 500); // 500ms debounce delay
    },
    [onSearch]
  );


  return (
    <section className="faq-filter-container">
      <div className="faq-filters-search">
        <Search
          placeholder="Search by title or description"
          enterButton
          allowClear
          value={searchText}
          onChange={handleInputChange}
        />
      </div>
    </section>
  )
}

export default FAQFilter